<template>
    <div>
        <nav class="main-header navbar navbar-expand navbar-white navbar-light">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"
                       data-widget="pushmenu"
                       href="#"
                    >
                      <i :style="{ color: sidebarColor }" class="fas fa-bars"></i>
                    </a>
                </li>
            </ul>
        </nav>

        <aside :style="{ backgroundColor: sidebarColor }"
               class="main-sidebar
               sidebar-dark-blue elevation-4"
        >

            <router-link :to="{ name: 'exemption-create' }" class="brand-link logo-switch">
                <img :src="miniLogoUrl ? miniLogoUrl : defaultMiniLogo"
                     alt="Afflex Docs Logo Small"
                     class="brand-image-xl logo-xs"
                >
                <img :src="logoUrl ? logoUrl : defaultLogo"
                     alt="Afflex Docs Logo Large"
                     class="brand-image-xs logo-xl"
                >
            </router-link>

            <div class="sidebar">
                <nav class="mt-2">
                    <ul class="nav nav-pills nav-sidebar flex-column"
                        data-widget="treeview"
                        role="menu"
                        data-accordion="false"
                    >
                        <li v-for="item in availableMenuItems" :key="item.routeName" class="nav-item" @click="menuItemClick">
                            <router-link class="nav-link" :to="{ name: item.routeName }">
                                <i class="fas" :class="item.icon"></i>
                                <p class="ml-2">{{ item.text }}</p>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <a :href="faqHref" target="_blank" class="nav-link">
                                <i class="fas fa-question-circle"></i>
                                <p class="ml-2">FAQ</p>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="logout">
                                <i class="fas fa-sign-out-alt"></i>
                                <p class="ml-2">Se déconnecter</p>
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
						<div class="sidebar-custom">
                <router-link class="btn btn-link first-button sidebar-custom__btn" :to="{ name: 'contact-us' }">
									<i class="fas fa-envelope"></i> Contact
                </router-link>
								<router-link class="btn btn-link hide-on-collapse pos-right sidebar-custom__btn" :to="{ name: 'general-usage-conditions' }">
									<i class="fas fa-tag"></i> CGU
								</router-link>
            </div>
        </aside>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import permissionManager from '../service/manager/permissionManager';
    export default {
        data() {
            return {
                defaultLogo: require('@/assets/img/logoAfflexWhite.png'),
                defaultMiniLogo: require('@/assets/img/miniLogoAfflexWhite.png'),
                faqHref: 'https://docs.google.com/document/d/1xzG5E_F8lMNd63-ItjBjyUVOk_TjHJqO0PD3tgb_yoA/edit?usp=sharing',
            };
        },
        computed: {
            ...mapGetters({
                enterpriseUuid: 'enterpriseUuid',
                sidebarColor: 'sidebarColor',
                logoUrl: 'logoUrl',
                miniLogoUrl: 'miniLogoUrl',
                userPermissions: 'userPermissions',
                enterpriseSettings: 'enterpriseSettings',
            }),
            availableMenuItems () {
                const permissions = this.userPermissions;
                if (!permissionManager.isValidPermissions(permissions)) {
                  return;
                }

                return this.menuItems.filter((item) => {
                    const isAvailableByPermission = permissionManager.isAvailableByPermission(permissions, item);

                    return this.enterpriseUuid
                        ? item && isAvailableByPermission
                        : true !== item.isEnterpriseRequired
                    ;
                });
            },
            menuItems() {
                return [
                    ...(this.enterpriseSettings.courseType !== 'token' ? [
                        {
                            icon: 'fa-edit',
                            routeName: 'exemption-create',
                            text: 'Nouvelle dispense',
                            isEnterpriseRequired: true,
                            permission: {
                                isCanCreateExemptions: true
                            }
                        }
                    ] : []),
                    {
                        icon: 'fa-list-ul',
                        routeName: 'exemption-list',
                        text: 'Gérer les dispenses',
                        isEnterpriseRequired: true,
                        permission: {
                            isCanViewExemptions: true
                        }
                    },
                    {
                        icon: 'fa-layer-group',
                        routeName: 'exemption-enterprises-list',
                        text: 'Dispenses par entreprise',
                        isEnterpriseRequired: false,
                        permission: {
                            isCanViewExemptions: true
                        }
                    },
                    {
                        icon: 'fas fa-check',
                        routeName: 'exemption-search',
                        text: 'Recherche des dispenses',
                        permission: {
                            isCanViewExemptions: true
                        }
                    },
                    ...(this.enterpriseSettings.sector === 'private' ? [
                        {
                            icon: 'fa-edit',
                            routeName: 'due-first-step',
                            text: 'DUE : créer',
                            isEnterpriseRequired: true,
                            permission: {
                                isCanCreateDues: true
                            }
                        },
                        {
                            icon: 'fa-list-ul',
                            routeName: 'due-list',
                            text: 'DUE : consulter',
                            isEnterpriseRequired: true,
                            permission: {
                                isCanViewDues: true
                            }
                        },
                    ] : []),
                    {
                        icon: 'fa-plus-circle',
                        routeName: 'manual-settings',
                        text: 'Paramétrage manuel',
                        isEnterpriseRequired: true,
                        permission: {
                            withoutPermission: true
                        }
                    },
                    {
                        icon: 'fa-university',
                        routeName: 'enterprise-list',
                        text: 'Mes entreprises',
                        isEnterpriseRequired: false
                    }
                ];
            },
        },
        watch: {
            enterpriseUuid(enterpriseUuid) {
                enterpriseUuid && this.$store.dispatch('setSettingsContext', { enterpriseUuid });
            },
        },
        async created() {
            this.enterpriseUuid && await this.$store.dispatch('setSettingsContext', { enterpriseUuid: this.enterpriseUuid });
        },
        methods: {
            ...mapActions({
                clearEnterpriseData: 'clearEnterpriseData',
                clearSettings: 'clearSettings',
                deleteAccessToken: 'deleteAccessToken',
                deleteCompany: 'deleteCompany',
                deleteUserPermissions: 'deleteUserPermissions',
                deleteRole: 'deleteRole',
            }),
            menuItemClick() {
                if (!document.body.classList.contains('sidebar-collapse')) {
                    window.$('[data-widget="pushmenu"]').PushMenu('collapse');
                }
            },
            logout() {
                this.clearEnterpriseData();
                this.clearSettings();
                this.deleteAccessToken();
                this.deleteCompany();
                this.deleteRole();
                this.deleteUserPermissions();
                this.$router.push({ name: 'login' });
            }
        }
    }
</script>

<style scoped lang="scss">
    .main-sidebar {
        position: fixed !important;
    }

    .logo-xs.brand-image-xl{
        top: 1rem;
        left: 1.5rem;
    }

    .logo-xs.brand-image-xs, .logo-xl.brand-image-xs{
        left: 5rem;
    }

    .main-header.navbar{
        padding: 0;
    }
</style>
